import { apiClient } from "./apiClient";

function isEmbedded() {
  try {
    return window.parent !== window;
  } catch {
    return false;
  }
}

async function apiPost(action, data) {
  try {
    const { data: response } = await apiClient.post("vinculacionController.php", { action, ...data });
    return response;
    } catch (err) {
    }
}

let sessionId = null;

export async function registrarIngreso(userId) {
  if (!isEmbedded() || !userId) return;
  const res = await apiPost("entrar", { user_id: userId });
  if (res.success && res.session_id) {
    sessionId = res.session_id;
  }
}

export async function registrarSalida() {
  if (!sessionId) return;
  await apiPost("salir", { session_id: sessionId });
  sessionId = null;
}

export function setupVinculacion(userId) {
  if (!isEmbedded() || !userId) return;

  registrarIngreso(userId);

  const handleBeforeUnload = () => registrarSalida();

  const handleVisibilityChange = () => {
    if (document.visibilityState === "hidden" && sessionId) {
      apiClient.post("vinculacionController.php", { action: "salir", session_id: sessionId }).catch(() => {});
    }
  };

  window.addEventListener("beforeunload", handleBeforeUnload);
  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    registrarSalida();
    window.removeEventListener("beforeunload", handleBeforeUnload);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
}
